import Http from "../../../../../core/http-axios-react/http/Http";
import { HttpBaseRequest } from "../../../../../core/HttpRequest";
import { HttpBaseResponse, HttpData } from "../../../../../core/HttpResponse";
import { Form_Create_PurchaseInvoice } from "../../../form/pembelian/add/Form";
import { Form_Update_PurchaseInvoice } from "../../../form/pembelian/belumLunas/Form";
import {
  M_InvoicePurchase,
  M_InvoicePurchaseDetail,
} from "../../../type/Invoice.type";

export interface Http_GET_PurchaseInvoices extends HttpBaseRequest {
  start_date?: string;
  end_date?: string;
  supplier_id?: string;
  payment_method_id?: string;
  status?: string;
}

export const getPurchaseInvoices = async ({
  end_date,
  keyword,
  page,
  payment_method_id,
  perPage,
  start_date,
  status,
  supplier_id,
}: Http_GET_PurchaseInvoices) => {
  const results = await Http.get<
    HttpBaseResponse<HttpData<M_InvoicePurchase[]>>
  >({
    url: "/invoice/purchase",
    params: {
      end_date,
      keyword,
      page,
      payment_method_id,
      perPage,
      start_date,
      status,
      supplier_id,
    },
  });
  return results;
};

export const getPurchaseInvoice = async ({
  purchase_invoice_id,
}: {
  purchase_invoice_id?: string;
}) => {
  const results = await Http.get<HttpBaseResponse<M_InvoicePurchaseDetail>>({
    url: "/invoice/purchase/detail",
    params: {
      purchase_invoice_id,
    },
  });
  return results;
};

export const addPurchaseInvoice = async ({
  payment_method_id,
  product_list,
  purchase_invoice_date,
  purchase_invoice_status,
  supplier_id,
  payment_due_date,
}: Form_Create_PurchaseInvoice) => {
  const results = await Http.post({
    url: "/invoice/purchase/insert",
    data: {
      payment_method_id,
      product_list,
      purchase_invoice_date,
      purchase_invoice_status,
      supplier_id,
      payment_due_date,
    },
  });
  return results;
};

export const payPurchaseInvoice = async ({
  purchase_invoice_id,
  payment_method_id,
}: Form_Update_PurchaseInvoice) => {
  const results = await Http.post({
    url: "/invoice/purchase/pay",
    data: {
      purchase_invoice_id,
      payment_method_id,
    },
  });
  return results;
};
